export const RESET = 'TICKET_LIST_RESET'
export const SET_ITEMS = 'TICKET_LIST_SET_ITEMS'
export const SET_ERROR = 'TICKET_LIST_SET_ERROR'
export const SET_VIEW = 'TICKET_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'TICKET_LIST_TOGGLE_LOADING'
